import React from 'react';

const encode = (data) => {
    return Object.keys(data)
        .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
        .join("&");
}

class FeedBackForm extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            name:'',
            email:'',
            moreMaps:'',
            message:''
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }
    handleChange(event){
        switch (event.target.name){
            case "message":
                this.setState({ message: event.target.value });
                break;
            case "moreMaps":
                this.setState({ moreMaps: event.target.value });
                break;
            case "name":
                this.setState({ name: event.target.value });
                break;
            case "email":
                this.setState({ email: event.target.value });
                break;
        }
    }
    // handleSubmit(event){
    //     console.log(this.state);
    //     event.preventDefault();
    // }
    handleSubmit = e => {
        fetch("/", {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: encode({ "form-name": "feedback", ...this.state })
        })
        // .then(function (response) {
            .then(() => {
            // if (response.data.success) {
                // handle success
                // console.log(encode({ "form-name": "feedback", ...this.state }));
                this.setState({
                    name: '',
                    email: '',
                    message: '',
                    moreMaps: '',
                    submitted: true
                });
            })
            // } else {
            //     // handle error
            //     alert("Something went wrong. Please try again.");
            // }

        // })
            .catch(error => alert("Something went wrong. Please try again."));
        // console.log(encode({ "form-name": "feedback", ...this.state }));
        e.preventDefault();
    };
    render(){
        return (
            <form onSubmit={this.handleSubmit}>
                <div className="form-group">
                    <label htmlFor="FormControlInput1">Name (optional)</label>
                    <input type="text" className="form-control" id="FormControlInput1" value={this.state.name} name="name" onChange={this.handleChange}/>
                </div>
                <div className="form-group">
                    <label htmlFor="FormControlInput2">Email address (optional)</label>
                    <input type="email" className="form-control" id="FormControlInput2" value={this.state.email} name="email" onChange={this.handleChange}/>
                    </div>
                <div className="form-group">
                    <label htmlFor="FormControlInput3">I'd like to see more maps for these categories (optional)</label>
                    <input type="text" className="form-control" id="FormControlInput3" value={this.state.moreMaps} placeholder="eg. Income trends in the state of Washington" name="moreMaps" onChange={this.handleChange} />
                </div>
                <div className="form-group">
                    <label htmlFor="FormControlTextarea4">Your Feedback</label>
                    <textarea value={this.state.message} className="form-control" id="FormControlTextarea4" rows="5" name="message" onChange={this.handleChange} required ></textarea>
                </div>
                <input className="btn btn-primary" type="submit" value="Submit" />
                {this.state.submitted ? (<div className="feedbackThanks"><p className="lead">
                    Thank you for your feedback. I highly appreciate it &#128522;
                        </p>
                    <p className="lead">
                        - Dhruv
                        </p></div>):null}
            </form>
        );
    }
}

class FeedbackPage extends React.Component{
    render(){
        return(
            <div className="container">
                <div className="jumbotron">
                    <h1 className="display-4">Feedback</h1>
                    <p className="lead">
                        I work on HandyMaps in my free time, and would like to make it a useful tool for its users. I'll appreciate any kind of feedback, positive or negative. &#128578;
                        </p>
                    <FeedBackForm />
                        </div>
                        </div>
        );
    }
}

export default FeedbackPage;